import { useBreakpointValue } from "@chakra-ui/react";

export function useMatchMenuWidth(): boolean | undefined {
  const shouldMatchWidth = useBreakpointValue({
    base: true,
    md: false,
  });
  return shouldMatchWidth;
}
